import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { useRecruitFqaPostsQuery } from '../generated/graphql'
import { Fqa } from './fqa'

const Outer = styled.div`
  --background-color: #00b2cc;
  width: 100%;
  margin-top: 2rem;
  @media (max-width: 40rem){
    margin-top: 0;
  }
`

type FqaSectionProps = {

}
export const FqaSection: FunctionComponent<FqaSectionProps> = () => {
  const recruitFqaQuery = useRecruitFqaPostsQuery()
  return <Outer>
    <Fqa faq={recruitFqaQuery.data?.recruitFqaPosts?.nodes?.slice().sort((a, b) => (a?.faq_fields?.num ?? 0) - (b?.faq_fields?.num ?? 0)).map(faq => ({number: faq?.faq_fields?.num ?? '', question: faq?.title ?? '', answer: faq?.faq_fields?.answer ?? ''})) ?? []} />
  </Outer>
}